<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Subscription Plans</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-data-table :headers="headers" :items="plans" :loading="loading"
                              :items-per-page="-1" hide-default-footer no-data-text="No record found"
                              class="text-left">
                    <template v-slot:item.product_skus="{ item }">
                        <v-chip-group>
                            <v-chip v-for="(sku, index) in item.product_skus" :key="index" size="x-small">
                                <span class="me-1">{{ sku.sku }}</span>
                            </v-chip>
                        </v-chip-group>
                    </template>
                    <template v-slot:item.price="{ item }">
                        {{ item.price }} {{ item.currency }}
                    </template>
                    <template v-slot:item.interval="{ item }">
                        {{ getIntervalTitle(item.interval) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn-group density="compact" divided variant="outlined">
                            <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                   size="x-small" @click="editPlan(item)">Edit
                            </v-btn>
                            <v-btn color="black" prepend-icon="mdi-plus" size="x-small" @click="planTemplate(item)">
                                GC
                            </v-btn>
                        </v-btn-group>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>

    <Create-Plan v-if="createDialogSwitch" v-model="createDialogSwitch" @addPlan="addPlan"/>
    <Edit-Plan v-if="editDialogSwitch" v-model="editDialogSwitch" :plan="selectedPlan" @updatePlan="updatePlan"/>

    <General-Template v-if="GCDialogSwitch" v-model="GCDialogSwitch" :plan="selectedPlan"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import EditPlan from "@/components/dialogs/plans/Edit.vue";
import CreatePlan from "@/components/dialogs/plans/Create.vue";
import GeneralTemplate from "@/components/dialogs/monitoring/templates/General.vue";

const plans = ref([]);
const loading = ref(true);
const {showSnackbar} = useSnackbarStore();
const createDialogSwitch = ref(false);
const editDialogSwitch = ref(false);
const GCDialogSwitch = ref(false);
const selectedPlan = ref(null);
const intervalTypes = [
    {value: 0, title: 'Monthly'},
    {value: 1, title: 'Quarterly'},
    {value: 2, title: 'Yearly'},
];
// SKUs is a list and Actions is a button group, so neither is sortable; the
// rest sort on their raw value (interval 0/1/2 sorts Monthly->Quarterly->Yearly).
const headers = [
    {title: 'Portal', key: 'portal'},
    {title: 'SKUs', key: 'product_skus', sortable: false},
    {title: 'Name', key: 'name'},
    {title: 'Price', key: 'price'},
    {title: 'Interval', key: 'interval'},
    {title: 'Actions', key: 'actions', sortable: false},
];

onMounted(() => {
    fetchPlans();
});

const getIntervalTitle = (interval) => {
    return intervalTypes.find((type) => type.value === interval).title
}
const fetchPlans = () => {
    send('get', `admin/subscription-plans`)
        .then((response) => {
            plans.value = response.data.data;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Plans could not be loaded', 'error')
        })
}
const addPlan = (plan) => {
    plans.value.unshift(plan);
}
const editPlan = (plan) => {
    selectedPlan.value = plan;
    editDialogSwitch.value = true;
}
const updatePlan = (plan) => {
    plans.value.map((item, index) => {
        if (item.id === plan.id) {
            plans.value[index] = plan;
        }
    });
}
const planTemplate = (plan) => {
    selectedPlan.value = plan;
    GCDialogSwitch.value = true;
}
const deletePlan = (plan) => {
    if (confirm(`Are you sure to delete "${plan.name}" plan?`)) {
        send('delete', `admin/subscription-plans/${plan.id}`)
            .then((response) => {
                if (response.data.success) {
                    plans.value.map((item, index) => {
                        if (item.id === plan.id) {
                            plans.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${plan.name}" Plan could not be deleted`, 'error')
                }
            })
    }
}
</script>
